import React from 'react'
import swal from 'sweetalert'
import { superAxiosRequest } from 'axiosApi'
import { localisationMaster } from 'Localisation/Localisation'
import { sumPerDay } from 'components/ContentBox/Groups/components/TimeTableCalendar/TimeTableCalendarFunctions'
import { dateFormat } from 'helpers/date'
import StudentPrice from 'components/ContentBox/Global/GlobalModalSingle/templates/groups/StudentPrice'
import Stores from 'Stores'
import groupStore from 'Stores/groupStore'
import cn from './InfoCardStudent.module.scss'
import { ReactComponent as TopUpIcon } from 'components/UI/icons/top_up.svg'
import { EditIconButton } from 'components/UI/SuperButton/SuperButton'
import VariantDelete from '../../../Global/GlobalModalSingle/templates/Ebooks/ModalExercise/VariantDelete/VariantDelete'
import asideModalStore from 'Stores/asideModalStore'
import { timeConverter } from '../../../Online-schedule/components/functions'
import useLocalization from 'hooks/useLocalization'

const getFromToString = (from, to) =>
  `${localisationMaster('text_17', 'groups/group', 'student')}: ${dateFormat(new Date(from), 'dd.mm.YYYY г.')}${to ? ` ${localisationMaster('text_18', 'groups/group', 'student')} ${dateFormat(new Date(to), 'dd.mm.YYYY г.')}` : ``}`

export default function InfoCardStudent(props) {
  const {
    balance,
    discount,
    surcharge,
    default_price_list,
    discount_list,
    surcharge_list,
    certificates,
    ...student
  } = props.student

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      training_status: 'Training Status',
      send_notification: 'Send notification',
      learning_status: 'Learning Status',
      discount: 'Discount',
      surcharge: 'Surcharge',
      edit: 'Edit',
      add: 'Add',
      edit_comment: 'Edit Comment',
      add_comment: 'Add Comment',
      comment: 'Comment',
      prices: 'Prices',
      add_certificate: 'Add Certificate',
      end_date: 'End Date',
      start_date: 'Start Date',
      price_type: 'Price Type',
      study_types: 'Study Types',
      today: 'Today',
      reset: 'Reset',
      change_training_dates_warning:
        "Changing training dates may lead to changes in the client's transactions and balance!",
    },
  })

  const customStyleFromRemoveBtn = {
    width: '30px',
    height: '30px',
  }

  const getBabkiBack = (balance, price, reverse) => {
    if (price && balance) {
      let ph = price.price_sum / price.hours_sum
      ph = sumPerDay(
        ph,
        surcharge
          ? ['surcharge', surcharge]
          : discount
            ? ['discount', discount]
            : false,
        props.default_price,
      )
      let cleanHourse = balance / 100 / ph
      if (reverse) cleanHourse = cleanHourse * -1
      return `${cleanHourse.toFixed(2)} ${price.hours_type.id === 1 ? localisationMaster('ac_h', 'groups/group') : localisationMaster('astr_h', 'groups/group')}`
    } else {
      return `0 ${price.hours_type.id === 1 ? localisationMaster('ac_h', 'groups/group') : localisationMaster('astr_h', 'groups/group')}`
    }
  }

  const openModalEditDiscountOrSurcharge = (discountOrSurcharge, type) => {
    const isDiscount = type === 'discount'
    const ms = {
      link: `groups/student_${isDiscount ? 'discounts' : 'surcharges'}/${discountOrSurcharge.id}`,
      action: isDiscount ? 'discount' : 'surcharge',
      button: localisationMaster('text_54', 'groups/all-groups'),
      title: `${Stores.transliterate(`${student.last_name} ${student.first_name}`)}: ${
        discountOrSurcharge[isDiscount ? 'discount_id' : 'surcharge_id']
          ? localisationMaster('text_15', 'groups/group', 'student')
          : localisationMaster('text_16', 'groups/group', 'student')
      }`,
      type: 'add-dors',
      is_put: true,
      margin_id: discountOrSurcharge.id,
      onSubmitSuccess: (data) =>
        groupStore.updateDiscountOrSurcharge(
          data,
          student.id,
          false,
          type,
          discountOrSurcharge.id,
        ),
    }
    const md = {
      group_id: +props.group_id,
      client_id: student.id,
      date_from: discountOrSurcharge.date_from,
      date_until: discountOrSurcharge.date_until,
    }
    if (discountOrSurcharge[isDiscount ? 'discount_id' : 'surcharge_id']) {
      md[isDiscount ? 'discount_id' : 'surcharge_id'] =
        discountOrSurcharge[isDiscount ? 'discount_id' : 'surcharge_id']
    }

    asideModalStore.activity(ms, md)
  }

  const openModalPrice = (price) => {
    const ms = {
      title: `${Stores.transliterate(`${student.last_name} ${student.first_name}`)} : ${localisationMaster('text_14', 'groups/group', 'student')}`,
      modalBodyComponent: () => <StudentPrice translate={translate} />,
      button: localisationMaster('text_54', 'groups/all-groups'),
      is_put: true,
      link: 'groups/student_default_price/' + price.id,
      data: 'json',
      //func: groupStore.updateSchedule TODO: change response
      onSubmitSuccess: () => groupStore.fetchGroup(props.group_id),
    }
    const md = {
      group_id: +props.group_id,
      client_id: student.id,
      date_from: price.date_from,
      date_until: price.date_until,
      default_price_id: price.default_price_id,
      default_price_name: price.default_price?.name,
    }

    asideModalStore.activity(ms, md)
  }

  const deleteDorS = (id, type) => {
    const name =
      type === 'discount'
        ? localisationMaster('text_12', 'groups/group', 'student')
        : localisationMaster('text_13', 'groups/group', 'student')
    swal({
      title: localisationMaster('text_2', 'alert'),
      text: `${localisationMaster('text_7', 'groups/group', 'student')} ${name}?`,
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const apiConf = {
          link: `groups/student_${type === 'discount' ? 'discounts' : 'surcharges'}/${id}`,
          method: 'delete',
        }
        superAxiosRequest(apiConf).then(() => {
          //groupStore.updateSchedule(res.data) // TODO: change response
          groupStore.deleteDorS(id, type)
          swal(
            '',
            `${localisationMaster('text_8', 'groups/group', 'student')} ${name}`,
            'success',
          )
        })
      } else {
        swal(localisationMaster('text_9', 'groups/group', 'student'))
      }
    })
  }

  const deletePrice = (id) => {
    swal({
      title: localisationMaster('text_2', 'alert'),
      text: `${localisationMaster('text_10', 'groups/group', 'student')}?`,
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const apiConf = {
          link: `groups/student_default_price/${id}`,
          method: 'delete',
        }
        superAxiosRequest(apiConf).then(() => {
          //groupStore.updateSchedule(res.data) TODO: change response
          groupStore.fetchGroup(props.group_id)
          swal(
            '',
            localisationMaster('text_11', 'groups/group', 'student'),
            'success',
          )
        })
      } else {
        swal(localisationMaster('text_9', 'groups/group', 'student'))
      }
    })
  }

  // const deleteCertificate = id => {
  //     swal({
  //         title: localisationMaster('text_2', 'alert'),
  //         text: `Вы действительно хотите удалить сертификат?`,
  //         icon: "warning",
  //         buttons: [localisationMaster('button_2', 'alert'), localisationMaster('button_1', 'alert')],
  //         dangerMode: true,
  //     }).then(yes => {
  //         if (yes) {
  //             const apiConf = {
  //                 link: `groups/del_student_cert_from_group/${id}`,
  //                 method: 'delete'
  //             }
  //             superAxiosRequest(apiConf).then(() => {
  //                 groupStore.fetchGroup(props.group_id)
  //                 swal("", "Сертификат успешно удален.")
  //             })
  //         } else {
  //             swal(localisationMaster('text_9', 'groups/group', 'student'))
  //         }
  //     })
  // }

  // const editCertificate = certificate => {
  //     const ms = {
  //         title: `Редактировать сертификат`,
  //         modalBodyComponent: () => <AddCertificate/>,
  //         button: localisationMaster('text_54', 'groups/all-groups'),
  //         link: 'groups/admin_add_cert_to_client/' + certificate.student_certificate_id,
  //         data: 'json',
  //         valid: {
  //             certificate: 'required',
  //             date_from: 'required',
  //         },
  //         onSubmitSuccess: () => groupStore.fetchGroup(props.group_id)
  //     }
  //     const md = {
  //         group_id: +props.group_id,
  //         client_id: student.id,
  //         certificate_id: certificate.certificate_id,
  //         student_certificate_id: certificate.student_certificate_id,
  //         date_from: certificate.date,
  //         certificate: certificate.certificate_id,
  //     }
  //
  //     asideModalStore.activity(ms, md)
  // }
  return (
    <div className={cn.box}>
      <div className={cn.studentInfo}>
        <div className={cn.additionalInfo}>
          <div className={cn.item}>
            <span className={cn.item__name}>ID:</span>
            <span className={cn.item__value}>{student.user_id}</span>
          </div>
          {/*<div className={cn.item}>*/}
          {/*    <span className={cn.item__name}>E-mail:</span>*/}
          {/*    <span className={cn.item__value}>{student.email}</span>*/}
          {/*</div>*/}
          <div className={cn.item}>
            <span className={cn.item__name}>Phone:</span>
            <span className={cn.item__value}>{student.phone}</span>
          </div>
          {student.whatsapp && (
            <div className={cn.item}>
              <span className={cn.item__name}>WhatsApp:</span>
              <span className={cn.item__value}>{student?.whatsapp}</span>
            </div>
          )}
          {student.telegram && (
            <div className={cn.item}>
              <span className={cn.item__name}>Telegram:</span>
              <span className={cn.item__value}>{student.telegram}</span>
            </div>
          )}
          <div className={cn.item}>
            <span className={cn.item__name}>Start Date:</span>
            <span className={cn.item__value}>
              {timeConverter(student.start_study_at, 'age')}
            </span>
          </div>
          <div className={cn.itemApplication}>
            <div className={cn.application}>
              <span className={cn.item__name}>Application:</span>
              <span className={`${cn.item__value} ${cn.notConcluded}`}>
                Not Concluded
              </span>
            </div>
            <div className={cn.btnContainer}>
              <button className={cn.btn}>Resend</button>
            </div>
          </div>
        </div>
      </div>
      {balance !== null && props.default_price ? (
        <div className={cn.balance}>
          {balance < 0 ? (
            <div>
              <span className={cn.balanceDebt}>Debt:</span>
              <b
                className={cn.balanceDebt}
              >{`${Stores.cleanSumm(-balance / 100)} ₸`}</b>
            </div>
          ) : (
            <div>
              <span>Remaining Payment:</span>
              <div className={cn.remainingPay}>
                <span>
                  <b>{`${Stores.cleanSumm(balance / 100)} ₸`}</b>
                </span>
                <span className={cn.time}>
                  {' '}
                  ({getBabkiBack(balance, props.default_price)})
                </span>
              </div>
            </div>
          )}
          <button className={cn.topUpButton} onClick={props.topUp}>
            <TopUpIcon />
            <span>Top Up Balance</span>
          </button>
        </div>
      ) : (
        <div className='sg-probka'>{`${localisationMaster('text_3', 'groups/group', 'student')}:`}</div>
      )}
      <div className={cn.params}>
        <div className={cn.col}>
          <span className={cn.colName}>Group Prices:</span>
          <div className={cn.param}>
            <span>
              {props.default_price && props.default_price.name}
              <br />
              {props.default_price && (
                <div className={cn.price}>
                  <span>
                    {Stores.cleanSumm(props.default_price.price_sum)} ₸
                  </span>
                  <span>|</span>
                  <span>
                    {props.default_price.hours_sum +
                      (props.default_price.hours_type.name === 'Академические'
                        ? ' ак.ч.'
                        : ' астр.ч.')}
                  </span>
                </div>
              )}
            </span>
          </div>
        </div>

        {!!default_price_list.length && (
          <div className={cn.col}>
            <span className={cn.colName}>Student Prices</span>
            {default_price_list.map((item) => (
              <div key={item.id} className={cn.param}>
                <div className={cn.cert}>
                  <div className={cn.cert__items}>
                    <span>{item.default_price?.name}</span>
                    <div className={cn.price}>
                      <span>
                        {Stores.cleanSumm(item.default_price.price_sum)}₸
                      </span>
                      <span>|</span>
                      <span>
                        {item.default_price.hours_sum +
                          (item.default_price.hours_type.minutes === 45
                            ? ' ак.ч.'
                            : ' астр.ч.')}
                      </span>
                    </div>
                    <span className={cn.activeDate}>
                      {getFromToString(item.date_from, item.date_until)}
                    </span>
                  </div>
                  <div className={cn.btns}>
                    <EditIconButton onClick={() => openModalPrice(item)} />
                    <VariantDelete
                      customStyle={customStyleFromRemoveBtn}
                      onClick={() => deletePrice(item.id)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {!!discount_list.length && (
          <div className={cn.col}>
            <span className={cn.colName}>Discounts:</span>
            <div className={cn.param}>
              {discount_list
                .sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
                .map(
                  (item, idx) =>
                    item.discount && (
                      <div className={cn.cert} key={idx}>
                        <div className={cn.cert__items}>
                          <span>{item.discount?.name}</span>
                          <div className={cn.price}>
                            <span>{item.discount.type_name}</span>
                            <span>|</span>
                            <span>
                              {item.discount?.count}
                              {item.discount?.type === 1 ? '₸' : '%'}
                            </span>
                          </div>
                          <span className={cn.activeDate}>
                            {getFromToString(item.date_from, item.date_until)}
                          </span>
                        </div>
                        <div className={cn.btns}>
                          <EditIconButton
                            onClick={() =>
                              openModalEditDiscountOrSurcharge(item, 'discount')
                            }
                          />
                          <VariantDelete
                            customStyle={customStyleFromRemoveBtn}
                            onClick={() => deleteDorS(item.id, 'discount')}
                          />
                        </div>
                      </div>
                    ),
                )}
            </div>
          </div>
        )}

        {!!surcharge_list.length && (
          <div className={cn.col}>
            <span className={cn.colName}>Surcharges:</span>
            <div className={cn.param}>
              {surcharge_list.map(
                (item) =>
                  item.surcharge && (
                    <div key={item.id} className={cn.param}>
                      <div className={cn.cert}>
                        <div className={cn.cert__items}>
                          <span>{item.surcharge?.name}</span>
                          <div className={cn.price}>
                            <span>{item.discount?.type_name}</span>
                            <span>|</span>
                            <span>
                              {item.surcharge.type_name} (
                              {item.surcharge?.count}
                              {item.surcharge?.type === 1 ? '₸' : '%'}
                            </span>
                          </div>
                          <span className={cn.activeDate}>
                            {getFromToString(item.date_from, item.date_until)}
                          </span>
                        </div>
                        <div className={cn.btns}>
                          <EditIconButton
                            onClick={() =>
                              openModalEditDiscountOrSurcharge(
                                item,
                                'surcharge',
                              )
                            }
                          />
                          <VariantDelete
                            customStyle={customStyleFromRemoveBtn}
                            onClick={() => deleteDorS(item.id, 'surcharge')}
                          />
                        </div>
                      </div>
                    </div>
                  ),
              )}
            </div>
          </div>
        )}

        {!!certificates.length && (
          <div className={cn.col}>
            <span className={cn.colName}>Certificates:</span>
            <div className={cn.param}>
              {certificates.map((item) => (
                <div key={item.student_certificate_id} className={cn.param}>
                  <div className={cn.cert}>
                    <div className={cn.cert__items}>
                      <div className={cn.price}>
                        <span>{item.certificate_name}</span>
                      </div>
                      <span className={cn.activeDate}>
                        Active: {dateFormat(new Date(item.date), 'dd.mm.YY')}
                      </span>
                    </div>
                    {/*<div className={cn.btns} >*/}
                    {/*    <EditIconButton onClick={() => editCertificate(item)}/>*/}
                    {/*    <VariantDelete customStyle={customStyleFromRemoveBtn} onClick={() => deleteCertificate(item.student_certificate_id)}/>*/}
                    {/*</div>*/}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {student.education_type !== null && (
          <div className={cn.col}>
            <span className={cn.colName}>Education type:</span>
            <div className={cn.param}>
              <div className={cn.cert}>
                <div className={cn.cert__items}>
                  <span>{student.education_type_name}</span>
                  <span className={cn.activeDate}>
                    {getFromToString(
                      student.start_study_at,
                      student.finish_study_at,
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
